<template>
  <div class="radio-history">
    <div class="container">
      <h1>Track History</h1>

      <template v-if="playHistory && playHistory.length > 0 && loading == false">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Time/Date</th>
              <th>Artist</th>
              <th>Track</th>
              <th class="time">Duration</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(track, index) in playHistory" v-if="index !== 0" :key="index">
              <td>
                <template v-if="track.artwork != null">
                  <img :src="track.artwork | secure" :alt="`${track.artist} - ${track.track}`">
                </template>
                <template v-else>
                  <img src="//placehold.it/300x300?text=MR">
                </template>
              </td>
              <td>{{ getTimePlayed(track.timestamp) }}</td>
              <td>
                <span>{{ track.artist }}</span>
                <span v-if="track.game" class="game">{{ track.game }}</span>
              </td>
              <td>{{ track.track }}</td>
              <td class="time">
                <span v-if="track.duration > 0">{{ getTrackDuration(track.duration) }}</span>
                <span v-else>N/A</span>
              </td>
            </tr>
          </tbody>
        </table>

        <router-link
          :to="{ path: `/history/${this.page + 1}` }"
          class="load-more button is-primary"
        >Load more</router-link>
      </template>
      <template v-else-if="loading == true">
        <div class="loading">
          <span class="fa fa-spinner fa-spin"></span>
          <span>Fetching history, hang tight...</span>
        </div>
      </template>
      <template v-else>
        <h4>There's nothing here!</h4>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "history",
  components: {},

  props: {},

  data() {
    return {
      playHistory: [],
      page: 1,
      loading: true
    };
  },

  watch: {
    "$route.params"(to, from) {
      this.page = parseInt(to.pageId);
      this.fetchHistory();
    }
  },

  filters: {
    secure(val) {
      if (val === null) return "//placehold.it/300x300?text=MR";
      return val.replace("http:", "https:");
    }
  },

  mounted() {
    if (this.$route.params.pageId != undefined)
      this.page = parseInt(this.$route.params.pageId);

    this.fetchHistory();
  },

  methods: {
    fetchHistory() {
      this.loading = true;
      this.$http
        .get(
          "https://radioapi.madnight.co.uk/history.php?type=json&page=" +
            this.page
        )
        .then(response => {
          if (
            response.data == undefined ||
            response.data == null ||
            response.status !== 200
          )
            return;

          response = response.data;

          this.playHistory = response.history;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
        });
    },

    getTimePlayed(timestamp) {
      timestamp = timestamp * 1000;
      return this.$moment(timestamp).format("Do MMM YYYY HH:mm:ss");
    },

    getTrackDuration(seconds) {
      var s = {
        hour: 3600000,
        minute: 60000,
        second: 1000
      };

      var timeRemainining = {};
      Object.keys(s).forEach(function(key) {
        timeRemainining[key] = Math.floor(seconds / s[key]);
        seconds -= timeRemainining[key] * s[key];
      });

      if (timeRemainining["hour"] > 0)
        return (
          this.pad(timeRemainining["hour"]) +
          `:` +
          this.pad(timeRemainining["minute"]) +
          `:` +
          this.pad(timeRemainining["seconds"])
        );

      return (
        this.pad(timeRemainining["minute"]) +
        `:` +
        this.pad(timeRemainining["second"])
      );
    },

    pad(number) {
      if (number < 10) return "0" + number;

      return number;
    }
  }
};
</script>

<style lang="scss">
.radio-history {
  h1 {
    font-size: 1.5rem;
    font-weight: bold;
    margin: 20px 0;
  }

  h4 {
    font-size: 1.2rem;
    font-style: italic;
    text-align: center;
    width: 100%;
  }

  table {
    border-spacing: 0;
    margin-bottom: 20px;

    tbody {
      tr {
        border-bottom: 1px solid $default-border-col;
        padding: 10px 0;
      }

      td {
        vertical-align: middle;
      }
    }

    img {
      display: inherit;
      height: 100px;
    }

    span,
    .game {
      clear: both;
      float: left;
    }

    .game {
      font-style: italic;
    }

    .time {
      text-align: right;

      span {
        float: none;
      }
    }
  }

  .fa-spin {
    margin-right: 10px;
  }

  .load-more {
    margin-bottom: 20px;
  }
}

body.is-dark {
  table {
    thead {
      th {
        color: $dark-color;
      }
    }
  }

  a.is-primary {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?dc96dd38